module.exports = __webpack_public_path__ + "static/media/warning-icon.e0a6c99c.svg";